import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * Renderiza texto com parágrafos (\n\n) e links inline em markdown [texto](url).
 * Links internos (começando com /) usam <Link> do router; externos abrem em nova aba.
 * Usado nas seções de conteúdo para permitir linkagem interna contextual.
 */
const LINK_RE = /\[([^\]]+)\]\(([^)]+)\)/g;

function parseInline(text: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let last = 0;
  let key = 0;
  let m: RegExpExecArray | null;
  LINK_RE.lastIndex = 0;
  while ((m = LINK_RE.exec(text))) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    const label = m[1];
    const href = m[2];
    if (href.startsWith('/')) {
      nodes.push(
        <Link key={key++} to={href} className="text-teal-deep font-medium hover:underline">
          {label}
        </Link>
      );
    } else {
      nodes.push(
        <a
          key={key++}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-teal-deep font-medium hover:underline"
        >
          {label}
        </a>
      );
    }
    last = m.index + m[0].length;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
}

export function RichText({ text, className }: { text?: string; className?: string }) {
  if (!text) return null;
  const paras = text.split(/\n\n+/);
  return (
    <div className={className}>
      {paras.map((para, i) => (
        <p
          key={i}
          className="font-body text-warm-gray leading-relaxed mb-4 last:mb-0 whitespace-pre-line"
        >
          {parseInline(para)}
        </p>
      ))}
    </div>
  );
}
